var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.91 259.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.41,
    y: 76.64,
    width: 20,
    height: 114.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.49,
    y: 76.64,
    width: 20,
    height: 114.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.56,19.2h-13.52s-47.91,0-47.91,0V5.86c0-3.24-2.62-5.86-5.86-5.86h-88.66c-3.24,0-5.86,2.62-5.86,5.86v13.34H10.34c-5.33,0-9.98,4.02-10.32,9.33-.38,5.82,4.24,10.67,9.98,10.67h13.86v183.07c0,20.6,16.7,37.3,37.3,37.3h121.58c20.6,0,37.3-16.7,37.3-37.3V39.2h13.86c5.74,0,10.36-4.84,9.98-10.67-.34-5.31-5-9.33-10.32-9.33Zm-33.52,203.07c0,9.54-7.76,17.3-17.3,17.3H61.16c-9.54,0-17.3-7.76-17.3-17.3V39.2h156.19v183.07Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0a8073e5d9cdbe3f08989473440475e5.svg";
export { ForwardRef as ReactComponent };